import "@fontsource/poppins";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";
import "@fontsource/poppins/900.css";
import { createTheme } from "@mui/material/styles";
import "@mui/styles";
export var colors = {
    // main
    primary: "#7938E1",
    secondary: "#F6C8C1",
    error: "#EB5757",
    info: "#2F80ED",
    success: "#33C3A1",
    border: "#F2F2F2",
    // basic
    black: "#2A2532",
    black_2: "#2A2532",
    blackOpacity: "rgba(0, 0, 0, 0.54)",
    black_3: "rgba(245, 245, 245, 0)",
    gray_3: "#828282",
    orange: "#FF721C",
    pink: "#EF86AE",
    pink_2: "#F44D8D",
    blue: "#2F7BE3",
    white: "#fff",
    whiteOpacity: "rgba(255, 255, 255, 0.6)",
    whiteOpacity2: "rgba(255, 255, 255, 0.9)",
    worldsBlue: "#3F4CDE",
    purple: "#7938E1",
    purple_2: "#A556CF",
    purple_3: "#E4DBFE",
    purple_4: "#BC93FF",
    darkGray: "#1E1A26",
    darkGray_transparent: "rgba(30, 26, 38, 0.68)",
    lightPurple: "rgb(134 118 255 / 30%)",
    darkred: "#D44E4E",
    gradient_1: "#A75EFF",
    gradient_2: "#7938E1",
    notStarted: "#585858",
    notificationCard: "rgba(121, 56, 225, 0.2)",
    engagement: {
        low: "#5974E9",
        medium: "#8015DD",
        high: "#A44ECC"
    },
    // types
    background: {
        secondary: "#FBFBFB",
        gray: "#BDBDBD",
        paper: "#EFF0F6",
        primary: "#BC9BF0",
        info: "#D0E1FB",
        success: "#CBEDD9",
        error: "#eb57576e",
        errorDarker: "rgba(212, 78, 78, 0.7)",
        orange: "#ff721c61",
        progress: "#D5EBF8",
        completed: "#D4F1E0",
        notStarted: "#E5E5E5"
    },
    npsChart: {
        promoters: "rgba(51, 195, 161, 1)",
        passive: "rgba(230, 230, 232, 1)",
        detractors: "rgba(212, 78, 78, 1)"
    },
    gradients: {
        main: "linear-gradient(25.18deg, #7938E1 0%, #7938E1 61.58%, #7938E1 100%)",
        secondary: "linear-gradient(22.65deg, #2F7BE3 21.29%, #3F4CDE 113.41%), #D9D9D9"
    },
    barChartColors: {
        lightPurple: "#8676FF",
        darkPurple: "#7938E1",
        deepBlue: "#2F7CF6",
        babyBlue: "#56CCF2"
    },
    chart: [""],
    heatmap: [
        "#F8F5FD",
        "#F2EBFC",
        "#E4D7F9",
        "#D7C3F6",
        "#C9AFF3",
        "#BC9BF0",
        "#AF88ED",
        "#A174EA",
        "#9460E7",
        "#864CE4",
        "#7938E1"
    ],
    heatmapStops: {
        lightBlue: ["#56CCF2", "#6FD4F4", "#80D9F5", "#91DEF7", "#A2E3F8"],
        darkBlue: ["#2F7CF6", "#4E90F7", "#639DF8", "#78AAF9", "#8DB7FA"],
        purple: ["#7938E1", "#8D56E6", "#9B6AE8", "#A87EEB", "#B592EF"]
    },
    courseFlowEditorBackground: "#E5E5E5"
};
colors.chart = [
    colors.barChartColors.lightPurple,
    colors.barChartColors.darkPurple,
    colors.barChartColors.deepBlue,
    colors.barChartColors.babyBlue,
    colors.primary,
    colors.secondary
];
colors.gradients.main = "linear-gradient(25.18deg, ".concat(colors.primary, " 0%, ").concat(colors.pink, " 61.58%, ").concat(colors.secondary, " 100%)");
var gradients = {
    main: "linear-gradient(25.18deg, ".concat(colors.primary, " 0%, ").concat(colors.pink, " 61.58%, ").concat(colors.secondary, " 100%)"),
    secondary: "linear-gradient(22.65deg, #2F7BE3 21.29%, #3F4CDE 113.41%), #D9D9D9"
};
var borderRadius = {
    small: 4,
    big: 10
};
// TODO remove - use colors.gradients.main
export var mainGradient = "linear-gradient(25.18deg, ".concat(colors.primary, " 0%, ").concat(colors.pink, " 61.58%, ").concat(colors.secondary, " 100%)");
export var borderPrimary = "1px solid ".concat(colors.border);
export var smallBorderRadius = 4;
export var bigBorderRadius = 10;
export var smallDrawerWidth = 65;
export var drawerWidth = 270;
export var spacing = 8;
export var bigCharacterLimit = 1000;
export var smallCharacterLimit = 250;
export var organisationStructureTreeItemWidth = 316;
export var gridPostCellSize = 80;
export var borders = {
    standard: "1px solid ".concat(colors.border),
    primary: "1px solid ".concat(colors.primary),
    secondary: "0.1px solid ".concat(colors.notStarted),
    notifications: "1px solid ".concat(colors.white)
};
export var shadows = {
    cardShadow: "0px 20px 40px rgba(184, 184, 184, 0.12)",
    secondary: "0px 4px 30px rgba(0, 0, 0, 0.03)",
    tertiary: "0px 4px 30px rgba(163, 163, 163, 0.07)",
    pinkShadow: "0px 20px 40px rgba(118, 16, 137, 0.1)"
};
export var typography = {
    fontFamily: "Poppins"
};
export var theme = createTheme({
    borders: borders,
    borderRadius: borderRadius,
    colors: colors,
    gradients: gradients,
    customShadows: shadows,
    typography: {
        fontFamily: [typography.fontFamily, "Helvetica", "Arial", "sans-serif"].join(","),
        fontSize: 14,
        button: {
            textTransform: "none"
        },
        h1: {
            fontSize: 24,
            lineHeight: "38px",
            letterSpacing: "0px"
        },
        h2: {
            fontSize: 20,
            lineHeight: "32px",
            letterSpacing: "0px"
        },
        semiBoldH2: {
            fontSize: 20,
            color: colors.black,
            lineHeight: "32px",
            fontWeight: 600
        },
        h3: {
            fontSize: 18,
            lineHeight: "27px",
            letterSpacing: "0px"
        },
        h4: {
            fontSize: 14,
            lineHeight: "24px",
            letterSpacing: "0px",
            color: colors.black // colors shouldn't be here in my opinion, but i left it as it was, due to high risk of ui bugs
        },
        h5: {
            fontSize: 12,
            lineHeight: "24px",
            letterSpacing: "0px"
        },
        body1: {
            fontSize: 14,
            lineHeight: "24px",
            letterSpacing: "0px"
        },
        body2: {
            fontSize: 14,
            lineHeight: "24px",
            letterSpacing: "0px",
            color: colors.black
        },
        body3: {
            fontSize: 16,
            lineHeight: "24px",
            letterSpacing: "0px",
            color: colors.black
        },
        mediumBody1: {
            fontSize: 14,
            lineHeight: "24px",
            letterSpacing: "0px",
            fontWeight: 500
        },
        semiBoldBody1: {
            fontSize: 14,
            lineHeight: "24px",
            letterSpacing: "0px",
            fontWeight: 600
        },
        boldBody1: {
            fontSize: 14,
            lineHeight: "24px",
            letterSpacing: "0px",
            fontWeight: 700
        },
        boldBody2: {
            fontSize: 14,
            lineHeight: "24px",
            letterSpacing: "0px",
            fontWeight: 700
        },
        semiBoldH3: {
            fontSize: 18,
            lineHeight: "27px",
            fontWeight: 600,
            letterSpacing: "0px"
        },
        semiBoldH5: {
            fontSize: "12px",
            lineHeight: "24px",
            fontWeight: 600,
            letterSpacing: "0px"
        },
        error: {
            fontSize: 14,
            lineHeight: "24px",
            letterSpacing: "0px",
            color: colors.error
        },
        caption: {
            fontSize: 12,
            lineHeight: "18px"
        }
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 960,
            desktop: 1280,
            lg: 1460,
            fullHd: 1920,
            xl: 2200,
            modal: 648
        }
    },
    palette: {
        common: {
            black: colors.black
        },
        primary: {
            main: colors.primary
        },
        secondary: {
            main: colors.secondary
        },
        error: {
            main: colors.error
        },
        warning: {
            main: colors.info
        },
        success: {
            main: colors.success
        },
        background: {
            paper: colors.background.paper
        }
    },
    shape: {
        borderRadius: smallBorderRadius
    },
    spacing: spacing,
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    backgroundColor: colors.white,
                    color: colors.black,
                    overflowX: "hidden"
                },
                img: {
                    maxWidth: "100%"
                }
            }
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: colors.white,
                    borderBottom: "1px solid ".concat(colors.background.secondary),
                    boxShadow: "none"
                }
            }
        },
        MuiFormControl: {
            defaultProps: {
                variant: "outlined"
            }
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    color: colors.black,
                    backgroundColor: colors.border,
                    fontSize: 13,
                    fontWeight: 500
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    lineHeight: "28px",
                    letterSpacing: "0.75px",
                    fontSize: 14,
                    fontWeight: 600,
                    paddingTop: 13,
                    paddingBottom: 13,
                    paddingLeft: 71,
                    paddingRight: 71,
                    boxShadow: "none"
                },
                sizeSmall: {
                    paddingTop: 8,
                    paddingBottom: 8,
                    paddingLeft: 34,
                    paddingRight: 34,
                    fontSize: 14
                },
                sizeLarge: {
                    paddingTop: 18,
                    paddingBottom: 18,
                    paddingLeft: 71,
                    paddingRight: 71
                },
                text: {
                    color: colors.primary,
                    lineHeight: "28px",
                    letterSpacing: "0.75px",
                    fontSize: 14,
                    fontWeight: 600,
                    paddingTop: 13,
                    paddingBottom: 13,
                    paddingLeft: 0,
                    paddingRight: 0,
                    boxShadow: "none"
                },
                contained: {
                    backgroundColor: colors.primary,
                    color: colors.white,
                    boxShadow: "none"
                },
                outlined: {
                    border: "double 2px transparent",
                    color: colors.primary,
                    background: "linear-gradient(".concat(colors.white, ",").concat(colors.white, ") padding-box, ").concat(colors.primary, " border-box;"),
                    lineHeight: "24px",
                    letterSpacing: "0.75px",
                    fontSize: 14,
                    fontWeight: 600,
                    paddingTop: 13,
                    paddingBottom: 13,
                    paddingLeft: 71,
                    paddingRight: 71,
                    boxShadow: "none"
                },
                containedSecondary: {
                    background: gradients.secondary,
                    backgroundColor: colors.worldsBlue,
                    color: colors.white,
                    boxShadow: "none"
                }
            },
            defaultProps: {
                variant: "contained"
            }
        },
        MuiAutocomplete: {
            styleOverrides: {
                option: {
                    "&[aria-selected='true']": {
                        backgroundColor: "transparent !important"
                    },
                    "&[data-focus='true']": {
                        backgroundColor: "rgba(121, 56, 225, 0.12)  !important"
                    }
                }
            }
        },
        MuiDivider: {
            styleOverrides: {
                light: {
                    borderColor: colors.background.secondary
                }
            }
        },
        MuiMenu: {
            styleOverrides: {
                paper: {
                    backgroundColor: colors.white,
                    border: "solid 1px ".concat(colors.background.secondary),
                    boxShadow: "0px 20px 40px rgba(184, 184, 184, 0.12)",
                    borderRadius: 10,
                    padding: spacing
                }
            },
            defaultProps: {
                elevation: 0,
                PaperProps: {
                    elevation: 0
                }
            }
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    padding: spacing * 2,
                    paddingTop: spacing * 2,
                    paddingBottom: spacing * 2,
                    borderBottom: "1px solid ".concat(colors.border)
                }
            }
        },
        MuiPopover: {
            styleOverrides: {
                paper: {
                    backgroundColor: colors.white,
                    boxShadow: "0px 20px 40px rgba(184, 184, 184, 0.12)"
                }
            },
            defaultProps: {
                elevation: 0,
                PaperProps: {
                    elevation: 0
                }
            }
        },
        MuiSnackbar: {
            styleOverrides: {
                anchorOriginTopRight: {
                    left: "16px !important",
                    right: "16px !important"
                }
            }
        },
        MuiFormControlLabel: {
            styleOverrides: {
                label: {
                    fontSize: 14,
                    lineHeight: "24px",
                    letterSpacing: "0.75px",
                    color: "black"
                }
            }
        },
        MuiAlert: {
            styleOverrides: {
                root: {
                    alignItems: "center",
                    color: colors.white,
                    height: "72px",
                    width: "100%"
                },
                standardError: {
                    backgroundColor: colors.error
                },
                standardInfo: {
                    backgroundColor: colors.info
                },
                standardSuccess: {
                    backgroundColor: colors.success
                },
                message: {
                    fontSize: "16px",
                    fontWeight: 600,
                    textAlign: "center",
                    width: "100%"
                },
                icon: {
                    display: "none"
                }
            }
        },
        MuiPaper: {
            styleOverrides: {
                elevation20: {
                    boxShadow: "0px 20px 40px rgba(184, 184, 184, 0.12);"
                },
                elevation8: {
                    boxShadow: "0px 20px 40px rgba(184, 184, 184, 0.12);"
                },
                elevation1: {
                    boxShadow: "none;",
                    border: "1px dashed ".concat(colors.background.gray),
                    borderImageSlice: 10,
                    borderRadius: 10
                }
            },
            defaultProps: {
                elevation: 0
            }
        },
        MuiCard: {
            defaultProps: {
                elevation: 0
            }
        },
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    backgroundColor: colors.white
                },
                paperAnchorDockedLeft: {
                    borderRight: "1px solid ".concat(colors.background.secondary)
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                input: {
                    lineHeight: "28px",
                    letterSpacing: "0.75px",
                    fontSize: 16,
                    fontWeight: 400
                }
            }
        },
        MuiList: {
            styleOverrides: {
                root: {
                    padding: 0
                }
            }
        },
        MuiListItemText: {
            styleOverrides: {
                root: {
                    fontWeight: 500,
                    ontSize: 14,
                    lineHeight: "24px",
                    letterSpacing: "0.75px"
                }
            }
        },
        MuiIconButton: {
            styleOverrides: {
                root: {
                    padding: 8
                }
            }
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: bigBorderRadius,
                    backgroundColor: colors.white
                }
            }
        },
        MuiTableHead: {
            styleOverrides: {
                root: {
                    backgroundColor: colors.background.paper
                }
            }
        },
        MuiTabs: {
            styleOverrides: {
                root: {
                    border: "1px solid ".concat(colors.border),
                    borderRadius: 10,
                    "& .MuiTab-root.Mui-selected": {
                        color: colors.black_2
                    },
                    "& .MuiTabs-indicator": {
                        background: colors.border,
                        borderRadius: "".concat(bigBorderRadius, "px ").concat(bigBorderRadius, "px 0 0"),
                        height: 9
                    }
                }
            }
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    paddingTop: 20,
                    paddingBottom: 27
                }
            }
        },
        MuiTableContainer: {
            styleOverrides: {
                root: {
                    borderRadius: bigBorderRadius,
                    paddingBottom: spacing * 2
                }
            }
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    borderBottom: "none",
                    letterSpacing: "0.75px",
                    lineHeight: "24px"
                }
            }
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    padding: "".concat(spacing * 3, "px ").concat(spacing * 4, "px")
                }
            }
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    padding: "".concat(spacing * 3, "px")
                },
                dividers: {
                    padding: "".concat(spacing * 3, "px ").concat(spacing * 4, "px")
                }
            }
        },
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    justifyContent: "center",
                    margin: 0,
                    padding: 24
                }
            }
        },
        MuiTypography: {
            defaultProps: {
                variantMapping: {
                    body3: "p",
                    mediumBody1: "p",
                    semiBoldBody1: "p",
                    boldBody1: "p",
                    boldBody2: "p",
                    error: "p",
                    semiBoldH3: "h3",
                    semiBoldH5: "h5",
                    semiBoldH2: "h2"
                }
            }
        },
        MuiSkeleton: {
            defaultProps: {
                animation: "pulse"
            }
        }
    }
});
Object.assign(theme, {
    overrides: {
        MUIRichTextEditor: {
            root: {
                textAlign: "left"
            },
            editor: {
                border: "1px solid gray"
            }
        }
    }
});
//# sourceMappingURL=data:application/json;base64,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